import { productApiClient } from '@/clients/ProductAPIClient';
import { IAlbum } from '@/data/models/album';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export default function useGetAlbumQuery(
  albumId: string
): UseQueryResult<IAlbum, Error> {
  async function queryFn() {
    const response = await productApiClient.getAlbum(albumId);
    return response.data;
  }

  return useQuery({
    queryFn,
    queryKey: ['album', albumId],
    staleTime: 10000,
  });
}
